export {PackageLocalizationProvider, getPackageLocalizationScript} from 'react-aria/private/i18n/server';
